import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePreClaimsMitigatedTypes } from './normalize';

export const fetchPreClaimsMitigatedTypes = createProvider(api.fetchPreClaimsMitigatedTypes)
  .andThen((res) => normalizePreClaimsMitigatedTypes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
